import { DeviceSettings, DeviceSettingsWithFallback } from "@Safemate/DefaultSettings/Settings/types";
import {Routine} from "redux-saga-routines";
import {Action, ActionFunctionAny} from "redux-actions";
import * as React from "react";
import { deconstructDeviceSettings, mapDeviceSettings, } from "@Safemate/DefaultSettings/Settings/utils";
import {
  settingsTabWrapper
} from "@Safemate/DefaultSettings/Settings/TabContent";
import {ButtonWrapper, CenteredRow} from "@Safemate/DefaultSettings/Settings/styled";
import {Form, Formik} from "formik";
import {Frame} from "@Safemate/styles";
import {Row} from "react-bootstrap";
import {FooterComp, FooterContext} from "@Safemate/DefaultSettings/Settings/footer";
import UnsavedCheck from "@Safemate/SaveNeeded/unsavedModal";
import {AppState} from "@Safemate/Store/types";
import {saveDeviceSettings} from "@Safemate/DefaultSettings/Store/routines";
import {connect} from "react-redux";
import DeviceHardware from "@Safemate/DefaultSettings/DeviceHardware";
import { useIntl } from "react-intl";
import { Tab } from "@Elements/Tabs";
import confirmModal from "@Safemate/Modals/confirmModal";
import { ClimaxConfigWarning } from "./ClimaxConfigWarning";
import { Checkbox } from "@Elements/CheckboxFormik";
import { getUserLocalStorage, setUserLocalStorage } from "@Safemate/utils";

interface DeviceSettingsProps{
  userId: number;
  tabs: JSX.Element[];
  deviceSettings: DeviceSettingsWithFallback;
  selectedDeviceHardwareId: number;
  saveDeviceSettings: Routine<ActionFunctionAny<Action<any>>>;
}

const DeviceSettingsComp = ({ tabs, deviceSettings, selectedDeviceHardwareId, saveDeviceSettings, userId  }: DeviceSettingsProps) => {

  const { formatMessage } = useIntl();  
  const settings: DeviceSettings = mapDeviceSettings(deviceSettings);

  const [ valuesToSave, setValuesToSave ] = React.useState<DeviceSettings>();

  const { Comp, func } = confirmModal();

  const { Comp: DelayedChangeComp, func: delayedChangeFunc } = confirmModal();

  const [ dontShow, setDontShow ] = React.useState(false);

  const hideReminder = getUserLocalStorage<boolean>(
    userId,
    "hideDefaultSettingsReminder",
    false
  );

  return(
    <Tab key={`deviceSettings`} title={formatMessage({id: "settings", defaultMessage: "Settings"})} name={`deviceSettings`}>
      <Formik
        initialValues={settings}
        enableReinitialize
        onSubmit={(values: DeviceSettings) => {
          if( values.silentAlarm === "1" && settings.silentAlarm === "0"){
            setValuesToSave(values);
            func(true);
          }
          else{
            saveDeviceSettings(deconstructDeviceSettings(values), selectedDeviceHardwareId)
            if(!hideReminder){
              delayedChangeFunc(true)
            }
          }
        }}
      >
        <Form>
          <Frame>
            <Row>
            <ClimaxConfigWarning/>
              <div style={{paddingBottom: "1em"}}>
                <ButtonWrapper>
                  <CenteredRow>
                    <DeviceHardware/>
                  </CenteredRow>
                </ButtonWrapper>
                {settingsTabWrapper(tabs)}
              </div>
              <FooterComp context={FooterContext.DEVICE_SETTINGS}/>
            </Row>
          </Frame>
          <UnsavedCheck />
        </Form>
      </Formik>
      <Comp
        standardBtn
        title={formatMessage({id: "silentAlarmWarnHeader", defaultMessage: "Risiko ved bruk av Lydløs alarm"})}
        body={
          <p>
            <span>{formatMessage({id: "silentAlarmWarnBody", defaultMessage: `Dersom du aktiverer Lydløs alarm, kan en klokke som nylig er blitt tilbakeringt forbli mutet.
Dersom den samme klokken også inngår i et kollegavarslingsteam, vil den da ikke kunne varsle bærer gjennom lyd, vibrasjon og visuell indikasjon, når en kollega utløser alarm.`})}</span>
          </p>
        }
        confirmText={formatMessage({id: "silentAlarmWarnAccept", defaultMessage: "OK, jeg forstår risikoen"})}
        confirmFunc={() => {
          saveDeviceSettings(deconstructDeviceSettings(valuesToSave), selectedDeviceHardwareId)
          if(!hideReminder){
            delayedChangeFunc(true)
          }
          func(false);
        }}
      />
      <DelayedChangeComp
        info
        disableClose
        buttonAlign="center"
        title={formatMessage({id: "defaultSettingsChangeInfo", defaultMessage: "Please note that this change will not take effect on every device immediately."})}
        body={<Checkbox
                id="change-reminder"
                value={dontShow}
                label={formatMessage({id: "dontShowAgain", defaultMessage: "Don't show again"})}
                onChange={(event: React.SyntheticEvent<HTMLInputElement>) => {
                  setDontShow(event.currentTarget.checked);
                }}
              />}
        cancelFunc={() => {
          if(dontShow){
            setUserLocalStorage(userId, "hideDefaultSettingsReminder", true)
          }
          delayedChangeFunc(false)
        }}
      />
    </Tab>
  )
}

const mapStateToProps = ({ appData: { user: { id }}, defaultSettings: {deviceHardware, settings: {deviceSettings}}}: AppState) => {
  return{
    userId: id,
    deviceSettings,
    selectedDeviceHardwareId: deviceHardware.selectedDeviceHardwareId,
  }
};

const mapDispatchToProps = {
  saveDeviceSettings
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceSettingsComp);
